import axios from "axios";
import { axiosGet, axiosPost, axiosPostResult } from "./ajaxServices";
import {
  urlRegistrationList,
  urlGetParticipant,
  urlRegistrationDetailByGroup,
  urlUpdateRegInfo,
  urlDeleteRegInfo,
  urlAvailableParticipant,
  urlGetParticipantByLabel,
  urlGetStandingList,
  urlRegistrationGroup,
  urlUpdateCampRegInfo,
  urlGetActivityList,
  urlGetWebpageGroups,
  urlSaveRegistrationGeneral,
  urlSaveHomePageInfo,
  urlSaveRegistrationGroup,
  urlChangeRegistrationStatus,
  urlGetRegistrationSettings,
  urlRegistrationTransaction,
  urlRegistrationTransactionByGroup,
  urlSaveRegistrationMain,
  urlSaveRegistrationWaiver,
  urlSaveRegistrationCheckout,
  urlAddUIForm,
  urlUpdateUIForm,
  urlDeleteUIForm,
  urlGetUIForms,
  urlGetReportNames,
  urlRunReport,
  urlGetBadges,
  urlSaveBadge,
  urlDeleteBadge,
  urlGetColumnPreferences,
  urlSaveColumnPreferences,
  urlGetMenuPermissions,
  urlUpdateMenuPermission,
  urlSaveWizardRegistration,
  urlGetTransactionDetail,
  urlGetTransactionsList,
  urlUpdateTransactionPayStatus,
  urlGetRegistrationTotals,
  urlGetRegistrationTotalParticipants,
  urlGetInvoiceData,
  urlSendInvoiceReceipt,
  urlGetRegistrationPaymentSettings,
  urlVoidTransaction,
  urlRefundTransaction,
  urlStaxVoidTransaction,
  urlStaxRefundTransaction,
  urlGetFacilityApplications,
  urlApproveFacilityApplication,
  urlRejectFacilityApplication,
  urlDeleteFacilityApplication,
  urlCreateFacilityReservation,
  urlGetFacilityCalendar,
  urlDeleteTransaction,
  urlDeleteRegistration,
} from "./CONSTANTS";

export const apiGetRegistrationList = (params) => {
  const url = urlRegistrationList;
  return new Promise((resolve, reject) => {
    axiosPost(url, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const apiGetRegistrationDetail = (params) => {
  const url = urlGetParticipant;
  return new Promise((resolve, reject) => {
    axiosPost(url, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const apiGetRegistrationDetailByLabel = (params) => {
  const url = urlGetParticipantByLabel;
  return new Promise((resolve, reject) => {
    axiosPost(url, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const apiGetAvailableParticipant = (params) => {
  const url = urlAvailableParticipant;
  return new Promise((resolve, reject) => {
    axiosPost(url, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const apiGetRegistrationDetailByGroup = (params) => {
  const url = urlRegistrationDetailByGroup;
  return new Promise((resolve, reject) => {
    axiosPost(url, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const apiGetRegistrationTransactionByGroup = (params) => {
  const url = urlRegistrationTransactionByGroup;
  return new Promise((resolve, reject) => {
    axiosPost(url, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const apiGetRegGroupData = (params) => {
  const url = urlRegistrationGroup;
  return new Promise((resolve, reject) => {
    axiosPost(url, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const apiGetRegistrationTransaction = (params) => {
  const url = urlRegistrationTransaction;
  return new Promise((resolve, reject) => {
    axiosPost(url, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const apiUpdateCampRegInfo = (params) => {
  const url = urlUpdateCampRegInfo;
  return new Promise((resolve, reject) => {
    axiosPost(url, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const apiUpdateRegInfo = (params) => {
  const url = urlUpdateRegInfo;
  return new Promise((resolve, reject) => {
    axiosPost(url, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const apiDeleteRegInfo = (params) => {
  const url = urlDeleteRegInfo;
  return new Promise((resolve, reject) => {
    axiosPost(url, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const apiDeleteTransaction = (params) => {
  const url = urlDeleteTransaction;
  return new Promise((resolve, reject) => {
    axiosPost(url, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const apiDeleteRegistration = (params) => {
  const url = urlDeleteRegistration;
  return new Promise((resolve, reject) => {
    axiosPost(url, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const apiGetStandingList = (params) => {
  const url = urlGetStandingList;
  return new Promise((resolve, reject) => {
    axiosPost(url, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const apiGetRegistrationTotals = (params) => {
  const url = urlGetRegistrationTotals;
  return new Promise((resolve, reject) => {
    axiosPost(url, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const apiGetRegistrationPaymentSettings = (params) => {
  const url = urlGetRegistrationPaymentSettings;
  return new Promise((resolve, reject) => {
    axiosPost(url, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const apiGetActivityList = (params) => {
  const url = urlGetActivityList;
  return new Promise((resolve, reject) => {
    axiosPostResult(url, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const apiGetWebpageGroups = (params) => {
  const url = urlGetWebpageGroups;
  return new Promise((resolve, reject) => {
    axiosPost(url, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};export const apiSaveRegistrationGeneral = (params) => {
  const url = urlSaveRegistrationGeneral;
  return new Promise((resolve, reject) => {
    axiosPost(url, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const apiSaveRegistrationCheckout = (params) => {
  const url = urlSaveRegistrationCheckout;
  return new Promise((resolve, reject) => {
    axiosPost(url, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const apiSaveHomePageInfo = (param) => {
  const url = urlSaveHomePageInfo;
  const config = {
    headers: {
      "content-type": "multipart/form-data",
    },
  };
  var formData = new FormData();
  formData.append("token", param.token);
  formData.append("announcement", param.announcement);
  formData.append("title", param.title);
  formData.append("registration_id", param.registrationID);
  if (param.home_background != "") {
    if (param.home_background instanceof File) {
      formData.append("home_background", param.home_background);
    }
  }
  if (param.home_logo != "") {
    if (param.home_logo instanceof File) {
      formData.append("home_logo", param.home_logo);
    }
  }
  if (param.home_info != "") {
    if (param.home_info instanceof File) {
      formData.append("home_info", param.home_info);
    }
  }
  return new Promise((resolve, reject) => {
    axiosPost(url, formData, config)
      .then(function (response) {
        resolve(response);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const apiSaveRegistrationMain = (params) => {
  const url = urlSaveRegistrationMain;
  return new Promise((resolve, reject) => {
    axiosPost(url, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const apiSaveRegistrationWaiver = (params) => {
  const url = urlSaveRegistrationWaiver;
  return new Promise((resolve, reject) => {
    axiosPost(url, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const apiSaveGroupInfo = (params) => {
  const url = urlSaveRegistrationGroup;
  return new Promise((resolve, reject) => {
    axiosPost(url, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const apiChangeRegistrationStatus = (params) => {
  const url = urlChangeRegistrationStatus;
  return new Promise((resolve, reject) => {
    axiosPost(url, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const apiGetRegistrationSettings = (params) => {
  const url = urlGetRegistrationSettings;
  return new Promise((resolve, reject) => {
    axiosPost(url, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const apiAddUiForm = (params) => {
  const url = urlAddUIForm;
  return new Promise((resolve, reject) => {
    axiosPost(url, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const apiUpdateUiForm = (params) => {
  const url = urlUpdateUIForm;
  return new Promise((resolve, reject) => {
    axiosPost(url, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const apiDeleteUiForm = (params) => {
  const url = urlDeleteUIForm;
  return new Promise((resolve, reject) => {
    axiosPost(url, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const apiGetUiForms = (params) => {
  const url = urlGetUIForms;
  return new Promise((resolve, reject) => {
    axiosPost(url, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const apiGetReportNames = (params) => {
  const url = urlGetReportNames;
  return new Promise((resolve, reject) => {
    axiosGet(url, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const apiRunReport = (params) => {
  const url = urlRunReport;
  return new Promise((resolve, reject) => {
    axiosPost(url, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const apiGetBadges = (params) => {
  const url = urlGetBadges;
  return new Promise((resolve, reject) => {
    axiosPost(url, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
        console.error('Failed to load badge list');
      });
  });
};

export const apiSaveBadge = (params) => {
  const url = urlSaveBadge;
  return new Promise((resolve, reject) => {
    axiosPost(url, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
        console.error('Failed to save badge');
      });
  });
};

export const apiDeleteBadge = (params) => {
  const url = urlDeleteBadge;
  return new Promise((resolve, reject) => {
    axiosPost(url, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
        console.error('Failed to delete badge');
      });
  });
};

export const apiGetColumnPreferences = (params) => {
  const url = urlGetColumnPreferences;
  return new Promise((resolve, reject) => {
    axiosPost(url, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
        console.error('Failed to load column preferences');
      });
  });
};

export const apiSaveColumnPreferences = (params) => {
  const url = urlSaveColumnPreferences;
  return new Promise((resolve, reject) => {
    axiosPost(url, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
        console.error('Failed to save column preferences');
      });
  });
};

export const apiGetMenuPermissions = (params) => {
  const url = urlGetMenuPermissions;
  return new Promise((resolve, reject) => {
    axiosPost(url, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const apiUpdateMenuPermission = (params) => {
  const url = urlUpdateMenuPermission;
  return new Promise((resolve, reject) => {
    axiosPost(url, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const apiSaveWizardRegistration = async (params) => {
  // Some environments route REST_Controller methods differently.
  const baseApi = urlSaveWizardRegistration.replace(/wizard\/save_wizard_registration.*/i, "");
  const origin = (() => {
    try {
      const u = new URL(urlSaveWizardRegistration);
      return u.origin + "/";
    } catch (e) {
      return baseApi;
    }
  })();

  const dedupe = new Set();
  const push = (v) => {
    if (v && !dedupe.has(v)) dedupe.add(v);
  };

  [
    urlSaveWizardRegistration,
    `${urlSaveWizardRegistration}/`,
    `${urlSaveWizardRegistration}_post`,
    `${urlSaveWizardRegistration}_post/`,
    `${baseApi}index.php/wizard/save_wizard_registration`,
    `${baseApi}index.php/wizard/save_wizard_registration/`,
    `${baseApi}index.php/wizard/save_wizard_registration_post`,
    `${baseApi}index.php/wizard/save_wizard_registration_post/`,
    `${origin}index.php/api/wizard/save_wizard_registration`,
    `${origin}index.php/api/wizard/save_wizard_registration/`,
    `${origin}index.php/api/wizard/save_wizard_registration_post`,
    `${origin}index.php/api/wizard/save_wizard_registration_post/`,
  ].forEach(push);

  const candidates = Array.from(dedupe);
  let lastErr = null;

  for (const target of candidates) {
    try {
      console.info('[apiSaveWizardRegistration] Trying', target);
      const res = await axios.post(target, params);
      const data = res?.data;
      const isSuccess = data?.result === true || data?.status === true || data?.registration_id;
      if (isSuccess) return data;
      throw new Error(data?.msg || 'Request failed');
    } catch (err) {
      const status = err?.response?.status;
      if (status === 404) {
        console.warn('[apiSaveWizardRegistration] 404 on', target);
        lastErr = err;
        continue;
      }
      console.error('Failed to save wizard registration', err);
      throw err;
    }
  }

  console.error('Failed to save wizard registration', lastErr);
  throw lastErr || new Error('Request failed');
};

export const apiGetTransactionDetail = (params) => {
  const url = urlGetTransactionDetail;
  return new Promise((resolve, reject) => {
    axiosPost(url, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
        console.error('Failed to get transaction detail');
      });
  });
};

export const apiGetTransactionsList = (params) => {
  const url = urlGetTransactionsList;
  return new Promise((resolve, reject) => {
    axiosPost(url, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
        console.error('Failed to get transactions list');
      });
  });
};

export const apiUpdateTransactionPayStatus = (params) => {
  const url = urlUpdateTransactionPayStatus;
  return new Promise((resolve, reject) => {
    axios
      .post(url, params)
      .then((res) => resolve(res.data))
      .catch((err) => {
        reject(err);
        console.error('Failed to update transaction pay status');
      });
  });
};

export const apiGetRegistrationTotalParticipants = (params) => {
  const url = urlGetRegistrationTotalParticipants;
  return new Promise((resolve, reject) => {
    axiosPost(url, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
        console.error('Failed to get registration total participants');
      });
  });
};

export const apiGetInvoiceData = (params) => {
  const url = urlGetInvoiceData;
  return new Promise((resolve, reject) => {
    axiosPost(url, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
        console.error('Failed to get invoice data');
      });
  });
};

export const apiSendInvoiceReceipt = (params) => {
  const url = urlSendInvoiceReceipt;
  return new Promise((resolve, reject) => {
    axiosPost(url, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
        console.error('Failed to send invoice receipt');
      });
  });
};

/**
 * Void a Forte transaction (same-day cancellation)
 * @param {object} params - {original_transaction_id, authorization_code, registration_id, domain, entered_by, token}
 */
export const apiVoidTransaction = (params) => {
  const url = urlVoidTransaction;
  return axios({
    method: 'PUT',
    url,
    data: params,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${params.token}`
    }
  })
  .then((res) => res.data)
  .catch((err) => {
    console.error('Failed to void transaction', err);
    throw err;
  });
};

/**
 * Void a Stax transaction (same-day cancellation)
 * @param {object} params - {original_transaction_id, registration_id, domain, entered_by, token}
 */
export const apiStaxVoidTransaction = (params) => {
  const url = urlStaxVoidTransaction;
  return axios({
    method: 'PUT',
    url,
    data: params,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${params.token}`
    }
  })
  .then((res) => res.data)
  .catch((err) => {
    console.error('Failed to void Stax transaction', err);
    throw err;
  });
};

/**
 * Refund a Forte transaction (full or partial refund)
 * @param {object} params - {original_transaction_id, authorization_amount, registration_id, domain, entered_by, token}
 */
export const apiRefundTransaction = (params) => {
  const url = urlRefundTransaction;
  return new Promise((resolve, reject) => {
    axiosPost(url, params)
      .then((res) => resolve(res))
      .catch((err) => {
        console.error('Failed to refund transaction', err);
        reject(err);
      });
  });
};

/**
 * Refund a Stax transaction (full or partial refund)
 * @param {object} params - {original_transaction_id, authorization_amount, registration_id, domain, entered_by, token}
 */
export const apiStaxRefundTransaction = (params) => {
  const url = urlStaxRefundTransaction;
  return new Promise((resolve, reject) => {
    axiosPost(url, params)
      .then((res) => resolve(res))
      .catch((err) => {
        console.error('Failed to refund Stax transaction', err);
        reject(err);
      });
  });
};

// Facility Application APIs
export const apiGetFacilityApplications = (params) => {
  const url = urlGetFacilityApplications;
  return new Promise((resolve, reject) => {
    axiosPost(url, params)
      .then((res) => resolve(res))
      .catch((err) => {
        console.error('Failed to get facility applications', err);
        reject(err);
      });
  });
};

export const apiApproveFacilityApplication = (params) => {
  const url = urlApproveFacilityApplication;
  return new Promise((resolve, reject) => {
    axiosPost(url, params)
      .then((res) => resolve(res))
      .catch((err) => {
        console.error('Failed to approve facility application', err);
        reject(err);
      });
  });
};

export const apiRejectFacilityApplication = (params) => {
  const url = urlRejectFacilityApplication;
  return new Promise((resolve, reject) => {
    axiosPost(url, params)
      .then((res) => resolve(res))
      .catch((err) => {
        console.error('Failed to reject facility application', err);
        reject(err);
      });
  });
};

export const apiDeleteFacilityApplication = (params) => {
  const url = urlDeleteFacilityApplication;
  return new Promise((resolve, reject) => {
    axiosPost(url, params)
      .then((res) => resolve(res))
      .catch((err) => {
        console.error('Failed to delete facility application', err);
        reject(err);
      });
  });
};

export const apiCreateFacilityReservation = (params) => {
  const url = urlCreateFacilityReservation;
  return new Promise((resolve, reject) => {
    axiosPost(url, params)
      .then((res) => resolve(res))
      .catch((err) => {
        console.error('Failed to create facility reservation', err);
        reject(err);
      });
  });
};

export const apiGetFacilityCalendar = (params) => {
  const url = urlGetFacilityCalendar;
  return new Promise((resolve, reject) => {
    axiosPost(url, params)
      .then((res) => resolve(res))
      .catch((err) => {
        console.error('Failed to get facility calendar', err);
        reject(err);
      });
  });
};
